import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown, false = anon, object = authed
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("verified_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const impersonate = async (userId) => {
    const { data } = await http.post(`/admin/users/${userId}/impersonate`);
    if (data.token) localStorage.setItem("verified_token", data.token);
    setUser({ ...data.user, impersonated_by: data.impersonated_by });
    return data.user;
  };

  const endImpersonation = async () => {
    const { data } = await http.post("/auth/end-impersonation");
    if (data.token) localStorage.setItem("verified_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    if (data.token) localStorage.setItem("verified_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } catch {}
    localStorage.removeItem("verified_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: fetchMe, impersonate, endImpersonation }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export { formatApiError };
